"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.forcedAlignment = exports.webhooks = exports.usage = exports.audioNative = exports.models = exports.user = exports.samples = exports.workspace = exports.conversationalAi = exports.v1TextToSpeechVoiceIdMultiStreamInput = exports.v1TextToSpeechVoiceIdStreamInput = exports.speechToText = exports.pronunciationDictionaries = exports.dubbing = exports.studio = exports.voices = exports.textToVoice = exports.speechToSpeech = exports.textToDialogue = exports.textToSpeech = exports.audioIsolation = exports.textToSoundEffects = exports.history = void 0;
exports.history = __importStar(require("./history"));
__exportStar(require("./history/types"), exports);
exports.textToSoundEffects = __importStar(require("./textToSoundEffects"));
__exportStar(require("./textToSoundEffects/types"), exports);
exports.audioIsolation = __importStar(require("./audioIsolation"));
__exportStar(require("./audioIsolation/types"), exports);
exports.textToSpeech = __importStar(require("./textToSpeech"));
__exportStar(require("./textToSpeech/types"), exports);
exports.textToDialogue = __importStar(require("./textToDialogue"));
__exportStar(require("./textToDialogue/types"), exports);
exports.speechToSpeech = __importStar(require("./speechToSpeech"));
__exportStar(require("./speechToSpeech/types"), exports);
exports.textToVoice = __importStar(require("./textToVoice"));
__exportStar(require("./textToVoice/types"), exports);
exports.voices = __importStar(require("./voices"));
__exportStar(require("./voices/types"), exports);
exports.studio = __importStar(require("./studio"));
__exportStar(require("./studio/types"), exports);
exports.dubbing = __importStar(require("./dubbing"));
__exportStar(require("./dubbing/types"), exports);
exports.pronunciationDictionaries = __importStar(require("./pronunciationDictionaries"));
__exportStar(require("./pronunciationDictionaries/types"), exports);
exports.speechToText = __importStar(require("./speechToText"));
__exportStar(require("./speechToText/types"), exports);
exports.v1TextToSpeechVoiceIdStreamInput = __importStar(require("./v1TextToSpeechVoiceIdStreamInput"));
__exportStar(require("./v1TextToSpeechVoiceIdStreamInput/types"), exports);
exports.v1TextToSpeechVoiceIdMultiStreamInput = __importStar(require("./v1TextToSpeechVoiceIdMultiStreamInput"));
__exportStar(require("./v1TextToSpeechVoiceIdMultiStreamInput/types"), exports);
exports.conversationalAi = __importStar(require("./conversationalAi"));
exports.workspace = __importStar(require("./workspace"));
exports.samples = __importStar(require("./samples"));
exports.user = __importStar(require("./user"));
exports.models = __importStar(require("./models"));
exports.audioNative = __importStar(require("./audioNative"));
exports.usage = __importStar(require("./usage"));
exports.webhooks = __importStar(require("./webhooks"));
exports.forcedAlignment = __importStar(require("./forcedAlignment"));
__exportStar(require("./history/client/requests"), exports);
__exportStar(require("./textToSoundEffects/client/requests"), exports);
__exportStar(require("./audioIsolation/client/requests"), exports);
__exportStar(require("./textToSpeech/client/requests"), exports);
__exportStar(require("./textToDialogue/client/requests"), exports);
__exportStar(require("./speechToSpeech/client/requests"), exports);
__exportStar(require("./textToVoice/client/requests"), exports);
__exportStar(require("./voices/client/requests"), exports);
__exportStar(require("./studio/client/requests"), exports);
__exportStar(require("./dubbing/client/requests"), exports);
__exportStar(require("./audioNative/client/requests"), exports);
__exportStar(require("./usage/client/requests"), exports);
__exportStar(require("./pronunciationDictionaries/client/requests"), exports);
__exportStar(require("./webhooks/client/requests"), exports);
__exportStar(require("./speechToText/client/requests"), exports);
__exportStar(require("./forcedAlignment/client/requests"), exports);
__exportStar(require("./conversationalAi/client/requests"), exports);
